/**
 * @module cercaliagl/control/LayerRegionsOptions
 */
/**
 * Options available for regions.<br/>
 * <ul>
 * <li><b>cercaliagl.control.LayerRegionsOptions.NONE</b>: No layer region option. Value: <code>none</code></li>
 * <li><b>cercaliagl.control.LayerRegionsOptions.NEIGHBORHOODS</b>: Layer neighborhoods. Value: <code>neighborhoods</code></li>
 * <li><b>cercaliagl.control.LayerRegionsOptions.POSTALCODES</b>: Layer postal codes. Value: <code>postalcodes</code></li>
 * <li><b>cercaliagl.control.LayerRegionsOptions.MUNICIPALITIES</b>: Layer municipalities. Value: <code>municipalities</code></li>
 * </ul>
 * <br/>
 * <b>Example</b>: Enable postal codes feature layer.<br/>
 * <br/>
 *
 * ```js
 * const map = new cercaliagl.Map({ target: 'map' });
 * const control = map.getControlByName(cercaliagl.control.MapControls.LAYER_REGIONS);
 * control.enableOption(cercaliagl.control.LayerRegionsOptions.POSTALCODES);
 * ```
 * <br/>
 *
 * @type {Object<string, string>}
 * @api
 */
var LayerRegionsOptions = {
    /**
     * No layer region option
     * @api
     */
    NONE: 'none',
    /**
     * Neighborhoods
     * @api
     */
    NEIGHBORHOODS: 'neighborhoods',
    /**
     * Postal codes
     * @api
     */
    POSTALCODES: 'postalcodes',
    /**
     * Municipalities
     * @api
     */
    MUNICIPALITIES: 'municipalities',
};
export default LayerRegionsOptions;
//# sourceMappingURL=LayerRegionsOptions.js.map